// extracted by mini-css-extract-plugin
export default {"optionsBox":"OptionsBox_optionsBox__Z4fKt","optionItem":"OptionsBox_optionItem__SO45F","active":"OptionsBox_active__szPHS"};